import { addItemToCollection } from "directus/src/operations";

// Flat git_repositories row: { project, repository_url, suffix } (no item/collection).
export async function createRepo(item) {
  try {
    const response = await addItemToCollection("git_repositories", item);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createChannel(item) {
  try {
    const response = await addItemToCollection("projects__integrations", item);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createFolder(item) {
  try {
    const response = await addItemToCollection("projects__integrations", item);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
